import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ShipmentUnLoadingForm from "./ShipmentUnLoadingComponents/ShipmentUnLoadingForm";

import { useAddShipmentUnLoadingMutation } from "store/services/shipmentUnLoadingApi";

import { useAppMeta } from "hooks";

const ShipmentUnLoadingCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment Unloading", path: "/app/crm/shipment-unLoading/list" },
    { title: "New Shipment Unloading" }];

  const [createShipmentUnLoading, { isLoading: creatingShipmentUnLoading }] =
    useAddShipmentUnLoadingMutation();

  // methods
  const handleAddSShipmentUnLoading = async (data) => {
    try {
      const response = await createShipmentUnLoading(data).unwrap();
      const records = response?.records || [];
      const _id = records[0]?.unloading?._id;
      toast.success(
        records.length > 1
          ? "Shipment Unloading Created! (2 records — destination and transit)"
          : "Shipment Unloading Created!"
      );
      navigate(`/app/crm/shipment-unLoading/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Shipment Unloading !"
      );
    }
  }
  useAppMeta("New Shipment Unloading");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipmentUnLoading}>
      <BreadcrumbLayout.Paper>
        <ShipmentUnLoadingForm isBusy={creatingShipmentUnLoading} onSubmit={handleAddSShipmentUnLoading} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default ShipmentUnLoadingCreateScreen